import { create } from './create'
import { modify } from './modify'

export const importProducts = [create, modify]
